<template>
<div>
  <div class="bg-primary-lightest py-10">
    <div class="static-container text-center sm:text-left">
      <h2 v-if="settings.title" class="text-6xl font-bold">
        {{ settings.title }}
      </h2>
    </div>
  </div>

  <div class="static-container py-10">
    <p v-if="failed" class="text-danger">Не удалось загрузить реквизиты. Пожалуйста, обновите страницу.</p>
    <div v-else class="prose max-w-full px-4 sm:px-0">
      <h2>{{ profile.name }}</h2>
      <div class="mt-6 border-t border-gray-100">
        <dl class="divide-y divide-gray-100">
          <div v-for="field in profileFields" :key="field.id" class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
            <dt class="text-sm/6 font-medium text-gray-900">{{ field.label }}</dt>
            <dd class="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{{ field.value }}</dd>
          </div>
        </dl>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import InjectsSeo from '@/mixins/InjectsSeo';
import axios from '@/zenky';

export default {
  mixins: [InjectsSeo],

  metaInfo() {
    return this.getMetaInfoFrom({
      title: this.settings.title,
    });
  },

  created() {
    this.loadProfile();
  },

  computed: {
    ...mapGetters({
      settings: 'settings/legalProfile',
    }),
  },

  methods: {
    async loadProfile() {
      if (this.isLoading) {
        return false;
      }

      this.isLoading = true;
      this.failed = false;

      try {
        const { data } = await axios.get('legal/profile/public');

        this.profile = data.data;

        this.generateFields();
      } catch (e) {
        this.failed = true;
      } finally {
        this.isLoading = false;
      }
    },

    generateFields() {
      if (!this.profile || !Array.isArray(this.profile.fields) || !this.profile.fields.length) {
        return;
      }

      const fields = {};

      this.profile.fields.forEach((field) => {
        fields[field.field] = field.value;
      });

      const profileFields = [];

      if (this.profile.legal_address) {
        profileFields.push({
          id: 'legal_address',
          label: 'Юридический адрес',
          value: this.profile.legal_address,
        });
      }

      if (this.profile.postal_address) {
        profileFields.push({
          id: 'postal_address',
          label: 'Почтовый адрес',
          value: this.profile.postal_address,
        });
      }

      Object.keys(this.labels).forEach((field) => {
        if (!fields[field]) {
          return;
        }

        profileFields.push({
          id: field,
          label: this.labels[field],
          value: fields[field],
        });
      });

      this.profileFields = profileFields;
    },
  },

  data() {
    return {
      profile: null,
      profileFields: [],
      isLoading: false,
      failed: false,
      labels: {
        inn: 'ИНН',
        ogrn: 'ОГРН',
        ceo: 'Руководитель',
        email: 'Email',
        bank: 'Банк',
        bic: 'БИК',
        ks: 'Корр. счёт',
        rs: 'Рассчётный счёт',
      },
    };
  },
}
</script>
